<template>
  <div class="edit-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ isEdit ? '编辑工单' : '新增工单' }}</span>
        <el-button style="float: right;" type="text" @click="goBack">返回</el-button>
      </div>
      
      <el-form :model="form" :rules="rules" ref="billForm" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构名称" prop="bill.referId">
              <el-select
                v-model="form.bill.referId"
                placeholder="请先选择机构名称"
                style="width: 100%"
                filterable
                clearable
                @focus="loadCompanyList"
                @change="handleCompanyChange"
              >
                <el-option
                  v-for="item in companyOptions"
                  :key="String(item.id)"
                  :label="item.name"
                  :value="String(item.id)">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="安装师傅" prop="bill.engineerId">
              <el-select
                v-model="form.bill.engineerId"
                filterable
                placeholder="请先选择机构"
                :loading="engineerLoading"
                :disabled="!form.bill.referId"
                style="width: 100%"
                @change="handleEngineerChange"
                clearable
              >
                <el-option
                  v-for="item in engineerOptions"
                  :key="String(item.id)"
                  :label="item.alias_name || item.user_name"
                  :value="String(item.id)">
                  <span>{{ item.alias_name || item.user_name }}</span>
                  <span style="color: #8492a6; font-size: 13px; margin-left: 10px;">{{ item.mobile }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="省市区" prop="bill.area">
              <el-cascader
                v-model="selectedArea"
                :options="areaOptions"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
                placeholder="请选择省市区"
                style="width: 100%"
                clearable
                @change="handleAreaChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="安装日期" prop="bill.planTime">
              <el-date-picker
                v-model="form.bill.planTime"
                type="datetime"
                placeholder="选择安装日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="计划安装数量" prop="bill.planCount">
              <el-input-number v-model="form.bill.planCount" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="bill.address">
              <el-input 
                v-model="form.bill.address" 
                placeholder="请输入详细安装地址（街道、门牌号等）"
                style="width: 100%"
                clearable>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>工单日志信息</el-divider>
        
        <el-button type="primary" size="small" icon="el-icon-plus" @click="addLog" style="margin-bottom: 15px;">添加日志</el-button>
        
        <el-table :data="form.logList" border stripe style="width: 100%">
          <el-table-column prop="devId" label="设备编号" width="180">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.devId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入设备编号"
                :remote-method="(query) => searchDevice(query, scope.$index)"
                :loading="deviceLoading[scope.$index]"
                size="small"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in deviceOptions[scope.$index] || []"
                  :key="item.devId || item.id"
                  :label="item.devId || item.id"
                  :value="item.devId || item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="carNo" label="车牌号" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.carNo" size="small" placeholder="请输入车牌号"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="devicePic" label="设备图片" width="200">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" type="primary" @click="triggerFileInput(scope.$index, 'devicePic')">上传</el-button>
                <input
                  :ref="`devicePicInput_${scope.$index}`"
                  style="display: none"
                  type="file"
                  accept="image/*"
                  @change="handleFileUpload($event, scope.$index, 'devicePic')"
                />
                <el-image 
                  v-if="scope.row.devicePic"
                  style="width: 60px; height: 60px; margin-left: 10px; vertical-align: middle; cursor: pointer;" 
                  :src="scope.row.devicePic" 
                  :preview-src-list="[scope.row.devicePic]"
                  fit="contain">
                </el-image>
                <span v-else style="color: #f56c6c; margin-left: 10px; font-size: 12px;">必填</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="carPic" label="车牌图片" width="200">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" @click="triggerFileInput(scope.$index, 'carPic')">上传</el-button>
                <input
                  :ref="`carPicInput_${scope.$index}`"
                  style="display: none"
                  type="file"
                  accept="image/*"
                  @change="handleFileUpload($event, scope.$index, 'carPic')"
                />
                <el-image 
                  v-if="scope.row.carPic"
                  style="width: 60px; height: 60px; margin-left: 10px; vertical-align: middle; cursor: pointer;" 
                  :src="scope.row.carPic" 
                  :preview-src-list="[scope.row.carPic]"
                  fit="contain">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="position1" label="安装位置1" width="200">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" type="primary" @click="triggerFileInput(scope.$index, 'position1')">上传</el-button>
                <input
                  :ref="`position1Input_${scope.$index}`"
                  style="display: none"
                  type="file"
                  accept="image/*"
                  @change="handleFileUpload($event, scope.$index, 'position1')"
                />
                <el-image 
                  v-if="scope.row.position1"
                  style="width: 60px; height: 60px; margin-left: 10px; vertical-align: middle; cursor: pointer;" 
                  :src="scope.row.position1" 
                  :preview-src-list="[scope.row.position1]"
                  fit="contain">
                </el-image>
                <span v-else style="color: #f56c6c; margin-left: 10px; font-size: 12px;">必填</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="position2" label="安装位置2" width="200">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" @click="triggerFileInput(scope.$index, 'position2')">上传</el-button>
                <input
                  :ref="`position2Input_${scope.$index}`"
                  style="display: none"
                  type="file"
                  accept="image/*"
                  @change="handleFileUpload($event, scope.$index, 'position2')"
                />
                <el-image 
                  v-if="scope.row.position2"
                  style="width: 60px; height: 60px; margin-left: 10px; vertical-align: middle; cursor: pointer;" 
                  :src="scope.row.position2" 
                  :preview-src-list="[scope.row.position2]"
                  fit="contain">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="position3" label="安装位置3" width="200">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" @click="triggerFileInput(scope.$index, 'position3')">上传</el-button>
                <input
                  :ref="`position3Input_${scope.$index}`"
                  style="display: none"
                  type="file"
                  accept="image/*"
                  @change="handleFileUpload($event, scope.$index, 'position3')"
                />
                <el-image 
                  v-if="scope.row.position3"
                  style="width: 60px; height: 60px; margin-left: 10px; vertical-align: middle; cursor: pointer;" 
                  :src="scope.row.position3" 
                  :preview-src-list="[scope.row.position3]"
                  fit="contain">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="position4" label="安装位置4" width="200">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" @click="triggerFileInput(scope.$index, 'position4')">上传</el-button>
                <input
                  :ref="`position4Input_${scope.$index}`"
                  style="display: none"
                  type="file"
                  accept="image/*"
                  @change="handleFileUpload($event, scope.$index, 'position4')"
                />
                <el-image 
                  v-if="scope.row.position4"
                  style="width: 60px; height: 60px; margin-left: 10px; vertical-align: middle; cursor: pointer;" 
                  :src="scope.row.position4" 
                  :preview-src-list="[scope.row.position4]"
                  fit="contain">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" size="small" style="color: #f56c6c" @click="removeLog(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item style="margin-top: 30px;">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import areaData from '@/assets/area-select-data.json';

export default {
  name: 'InstallBillEdit',
  data() {
    return {
      isEdit: false,
      form: {
        bill: {
          id: null,
          installBillNo: '',
          engineerId: null,
          engineerName: '',
          engineerPhone: '',
          referId: null,
          area: '',
          address: '', // 新增详细地址字段
          planTime: '',
          planCount: 0,
          status: 1
        },
        logList: []
      },
      areaOptions: areaData,
      selectedArea: [],
      engineerOptions: [],
      engineerLoading: false,
      companyOptions: [],
      deviceOptions: {}, // 设备选项，按行索引存储
      deviceLoading: {}, // 设备加载状态，按行索引存储
      rules: {
        'bill.engineerId': [
          { required: true, message: '请选择安装师傅', trigger: 'change' }
        ],
        'bill.referId': [
          { required: true, message: '请选择机构名称', trigger: 'change' }
        ],
        'bill.area': [
          { required: true, message: '请选择省市区', trigger: 'change' }
        ],
        'bill.address': [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        'bill.planTime': [
          { required: true, message: '请选择安装日期', trigger: 'change' }
        ],
        'bill.planCount': [
          { required: true, message: '请输入计划安装数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '计划安装数量必须大于0', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    const installBillNo = this.$route.query.installBillNo;
    
    // 先加载机构列表，确保机构列表加载完成后再获取详情（用于回显）
    this.loadCompanyList().then(() => {
      if (installBillNo) {
        this.isEdit = true;
        this.getDetail(installBillNo);
      }
    });
  },
  methods: {
    // 获取工单详情
    getDetail(installBillNo) {
      this.$http.post('/manage/installBill/detail', { installBillNo })
        .then(res => {
          if (res.data.code === 0) {
            const billData = res.data.data.bill || {};
            // 只保留需要的字段
            // 确保 referId 和 engineerId 转换为字符串，与下拉框的 value 类型一致
            this.form.bill = {
              id: billData.id || null,
              installBillNo: billData.installBillNo || '',
              engineerId: billData.engineerId ? String(billData.engineerId) : null,
              engineerName: billData.engineerName || '',
              engineerPhone: billData.engineerPhone || '',
              referId: billData.referId ? String(billData.referId) : null,
              area: billData.area || '',
              address: billData.address || '', // 回显详细地址
              planTime: billData.planTime || '',
              planCount: billData.planCount || 0,
              status: billData.status !== undefined ? billData.status : 1
            };
            this.form.logList = res.data.data.logList || [];
            
            // 使用 $nextTick 确保机构列表已渲染后再设置值
            this.$nextTick(() => {
              // 回显省市区选择
              if (this.form.bill.area) {
                this.selectedArea = this.getAreaValuesFromString(this.form.bill.area);
              }
              
              // 确保机构下拉框能正确回显
              // 再次使用 $nextTick 确保机构列表选项已完全渲染
              this.$nextTick(() => {
                // 机构列表已在 mounted 中加载完成，直接加载该机构下的安装师傅列表
                if (this.form.bill.referId) {
                  this.loadEngineersByCompany(this.form.bill.referId).then(() => {
                    // 安装师傅列表加载完成后，再次使用 $nextTick 确保下拉框已渲染
                    this.$nextTick(() => {
                      // 此时机构名称和安装师傅应该都能正确回显了
                    });
                  });
                }
              });
            });
          } else {
            this.$message.error(res.data.message || '获取详情失败');
          }
        })
        .catch(err => {
          this.$message.error('网络请求失败');
          console.error(err);
        });
    },
    
    // 根据机构ID加载该机构下的所有安装师傅
    loadEngineersByCompany(companyId) {
      if (!companyId) {
        this.engineerOptions = [];
        return Promise.resolve();
      }
      
      this.engineerLoading = true;
      const params = {
        page: 1,
        limit: 1000, // 获取该机构下的所有安装师傅
        user_type: 3,
        user_name: '',
        alias_name: '',
        mobile: '',
        wechat: '',
        mail: '',
        ins_id: companyId
      };
      
      return this.$http.get('/manage/user-info/page/', { params })
        .then(res => {
          if (res.data.code === 0) {
            this.engineerOptions = res.data.data.records || [];
            // 使用 $nextTick 确保安装师傅列表已渲染
            return this.$nextTick();
          } else {
            this.engineerOptions = [];
            this.$message.error(res.data.message || '获取安装师傅列表失败');
            return Promise.resolve();
          }
        })
        .catch(err => {
          console.error(err);
          this.engineerOptions = [];
          this.$message.error('获取安装师傅列表失败');
          return Promise.resolve();
        })
        .finally(() => {
          this.engineerLoading = false;
        });
    },
    
    // 处理机构选择变化
    handleCompanyChange(value) {
      // 当机构改变时，清空已选择的安装师傅
      this.form.bill.engineerId = null;
      this.form.bill.engineerName = '';
      this.form.bill.engineerPhone = '';
      this.engineerOptions = [];
      
      // 如果选择了机构，加载该机构下的所有安装师傅
      if (value) {
        this.loadEngineersByCompany(value);
      }
    },
    
    // 处理安装师傅选择变化
    handleEngineerChange(value) {
      if (value) {
        const engineer = this.engineerOptions.find(e => e.id === value);
        if (engineer) {
          this.form.bill.engineerName = engineer.alias_name || engineer.user_name;
          this.form.bill.engineerPhone = engineer.mobile || '';
        }
      } else {
        this.form.bill.engineerName = '';
        this.form.bill.engineerPhone = '';
      }
    },
    
    // 加载机构列表
    loadCompanyList() {
      if (this.companyOptions.length > 0) {
        return Promise.resolve(); // 已加载过，返回已解决的Promise
      }
      
      const params = {
        pageNum: 1,
        pageSize: 1000
      };
      
      return this.$http.post('/manage/institution/list', params)
        .then(res => {
          if (res.data.code === 0) {
            this.companyOptions = res.data.data.records || [];
            // 使用 $nextTick 确保机构列表已渲染
            return this.$nextTick();
          } else {
            this.$message.error(res.data.message || '获取机构列表失败');
            return Promise.resolve();
          }
        })
        .catch(err => {
          this.$message.error('网络请求失败');
          console.error(err);
          return Promise.resolve();
        });
    },
    
    // 处理省市区选择变化
    handleAreaChange(value) {
      if (value && value.length > 0) {
        const labels = this.getAreaLabels(value);
        // 将省市区拼接成字符串，格式：省|市|区
        this.form.bill.area = labels.filter(Boolean).join('|');
      } else {
        this.form.bill.area = '';
      }
    },
    
    // 根据选中的value获取label
    getAreaLabels(values) {
      const labels = [];
      let currentOptions = this.areaOptions;
      
      for (let i = 0; i < values.length; i++) {
        const item = currentOptions.find(opt => opt.value === values[i]);
        if (item) {
          labels.push(item.label);
          currentOptions = item.children || [];
        }
      }
      
      return labels;
    },
    
    // 根据区域字符串（格式：省|市|区）获取value数组
    getAreaValuesFromString(areaString) {
      if (!areaString) return [];
      
      const parts = areaString.split('|');
      if (parts.length === 0) return [];
      
      const values = [];
      
      // 查找省
      const provinceItem = this.areaOptions.find(p => p.label === parts[0]);
      if (!provinceItem) return [];
      values.push(provinceItem.value);
      
      if (parts.length < 2 || !provinceItem.children) return values;
      
      // 查找市
      const cityItem = provinceItem.children.find(c => c.label === parts[1]);
      if (!cityItem) return values;
      values.push(cityItem.value);
      
      if (parts.length < 3 || !cityItem.children) return values;
      
      // 查找区
      const districtItem = cityItem.children.find(d => d.label === parts[2]);
      if (!districtItem) return values;
      values.push(districtItem.value);
      
      return values;
    },
    
    // 添加日志
    addLog() {
      // 如果是新增且还没有工单编号，先生成一个临时编号
      let installBillNo = this.form.bill.installBillNo;
      if (!installBillNo) {
        const now = new Date();
        const dateStr = now.getFullYear() + 
          String(now.getMonth() + 1).padStart(2, '0') + 
          String(now.getDate()).padStart(2, '0');
        const timeStr = String(now.getHours()).padStart(2, '0') + 
          String(now.getMinutes()).padStart(2, '0') + 
          String(now.getSeconds()).padStart(2, '0');
        installBillNo = 'GDBH' + dateStr + timeStr + Math.floor(Math.random() * 1000).toString().padStart(3, '0');
        this.form.bill.installBillNo = installBillNo;
      }
      
      const newIndex = this.form.logList.length;
      this.$set(this.deviceOptions, newIndex, []);
      this.$set(this.deviceLoading, newIndex, false);
      
      this.form.logList.push({
        installBillNo: installBillNo,
        devId: null,
        carNo: '',
        devicePic: '',
        carPic: '',
        position1: '',
        position2: '',
        position3: '',
        position4: '',
        status: 1
      });
    },
    
    // 删除日志
    removeLog(index) {
      this.$confirm('确定删除该日志吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.logList.splice(index, 1);
        // 清理对应的设备选项和加载状态
        this.$delete(this.deviceOptions, index);
        this.$delete(this.deviceLoading, index);
        this.$message.success('删除成功');
      }).catch(() => {});
    },
    
    // 搜索设备（远程搜索）
    searchDevice(query, index) {
      if (query !== '') {
        this.$set(this.deviceLoading, index, true);
        const params = {
          pageNum: 1,
          pageSize: 20,
          devId: query
        };
        
        this.$http.post('/manage/dev/list', params)
          .then(res => {
            if (res.data.code === 0) {
              this.$set(this.deviceOptions, index, res.data.data.records || []);
            } else {
              this.$set(this.deviceOptions, index, []);
            }
          })
          .catch(err => {
            console.error(err);
            this.$set(this.deviceOptions, index, []);
          })
          .finally(() => {
            this.$set(this.deviceLoading, index, false);
          });
      } else {
        this.$set(this.deviceOptions, index, []);
      }
    },
    
    // 触发文件选择
    triggerFileInput(index, field) {
      let refName = '';
      if (field === 'devicePic') {
        refName = `devicePicInput_${index}`;
      } else if (field === 'carPic') {
        refName = `carPicInput_${index}`;
      } else if (field === 'position1') {
        refName = `position1Input_${index}`;
      } else if (field === 'position2') {
        refName = `position2Input_${index}`;
      } else if (field === 'position3') {
        refName = `position3Input_${index}`;
      } else if (field === 'position4') {
        refName = `position4Input_${index}`;
      }
      
      const ref = this.$refs[refName];
      if (ref) {
        // ref可能是数组或单个元素
        const input = Array.isArray(ref) ? ref[0] : ref;
        if (input) {
          input.click();
        }
      }
    },
    
    // 处理文件上传
    handleFileUpload(event, index, field) {
      const file = event.target.files[0];
      if (!file) return;
      
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件');
        event.target.value = '';
        return;
      }
      
      // 验证文件大小（限制为5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB');
        event.target.value = '';
        return;
      }
      
      // 上传文件
      const headers = {
        'Content-Type': 'multipart/form-data'
      };
      const formData = new FormData();
      formData.append('file', file);
      
      this.$http.post('/manage/file/upload', formData, { headers })
        .then(res => {
          if (res.data.code === 0) {
            // 接口返回的路径在 message 字段中
            const fileUrl = res.data.message;
            if (field === 'devicePic') {
              this.form.logList[index].devicePic = fileUrl;
            } else if (field === 'carPic') {
              this.form.logList[index].carPic = fileUrl;
            } else if (field === 'position1') {
              this.form.logList[index].position1 = fileUrl;
            } else if (field === 'position2') {
              this.form.logList[index].position2 = fileUrl;
            } else if (field === 'position3') {
              this.form.logList[index].position3 = fileUrl;
            } else if (field === 'position4') {
              this.form.logList[index].position4 = fileUrl;
            }
            this.$message.success('上传成功');
          } else {
            this.$message.error(res.data.message || '上传失败');
          }
        })
        .catch(err => {
          this.$message.error('上传失败');
          console.error(err);
        })
        .finally(() => {
          // 清空文件选择，允许重复选择同一文件
          event.target.value = '';
        });
    },
    
    // 提交表单
    submitForm() {
      this.$refs.billForm.validate((valid) => {
        if (valid) {
          // 验证日志列表中的必填项
          if (!this.form.logList || this.form.logList.length === 0) {
            this.$message.error('请至少添加一条工单日志');
            return false;
          }
          
          // 验证每条日志的必填项
          for (let i = 0; i < this.form.logList.length; i++) {
            const log = this.form.logList[i];
            if (!log.devId || log.devId === '') {
              this.$message.error(`第${i + 1}条日志：请选择设备编号`);
              return false;
            }
            if (!log.devicePic || log.devicePic === '') {
              this.$message.error(`第${i + 1}条日志：请上传设备图片`);
              return false;
            }
            if (!log.position1 || log.position1 === '') {
              this.$message.error(`第${i + 1}条日志：请上传安装位置1图片`);
              return false;
            }
          }
          
          // 如果是新增，生成工单编号（如果后端不自动生成）
          if (!this.isEdit && !this.form.bill.installBillNo) {
            // // 可以根据需要生成工单编号，或让后端自动生成
            const now = new Date();
            const dateStr = now.getFullYear() + 
              String(now.getMonth() + 1).padStart(2, '0') + 
              String(now.getDate()).padStart(2, '0');
            const timeStr = String(now.getHours()).padStart(2, '0') + 
              String(now.getMinutes()).padStart(2, '0') + 
              String(now.getSeconds()).padStart(2, '0');
            this.form.bill.installBillNo = 'GDBH' + dateStr + timeStr + Math.floor(Math.random() * 1000).toString().padStart(3, '0');
          }
          
          // 给所有日志项设置工单编号
          this.form.logList.forEach(log => {
            log.installBillNo = this.form.bill.installBillNo;
          });
          
          const url = this.isEdit ? '/manage/installBill/update' : '/manage/installBill/save';
          const method = this.isEdit ? 'put' : 'post';
          
          this.$http[method](url, this.form)
            .then(res => {
              if (res.data.code === 0) {
                this.$message.success(this.isEdit ? '修改成功' : '创建成功');
                this.goBack();
              } else {
                this.$message.error(res.data.message || '操作失败');
              }
            })
            .catch(err => {
              this.$message.error('网络请求失败');
              console.error(err);
            });
        } else {
          this.$message.error('请检查表单填写');
          return false;
        }
      });
    },
    
    // 返回
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.edit-container {
  padding: 20px;
}
.box-card {
  width: 100%;
  margin: 0 auto;
}
</style>